module.exports = __webpack_public_path__ + "../front/img/468_3_skuffer+trådkurv+hylde.3039deae.svg";